import stateFilter from '../modules/stateFilter';
export default {
  init() {
    stateFilter();
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./assets/src/js/routes/register.js